import { onBeforeMount, onBeforeUnmount } from 'vue';
import { createConsumer } from '@rails/actioncable';

const consumer = createConsumer();

export default function useActionCable(channel, callbacks) {
  const subscription = consumer.subscriptions.create(channel, callbacks);

  onBeforeMount(() => {
    const subscriptionExists = consumer.subscriptions.findAll(subscription.identifier).length > 1;
    if (subscriptionExists) {
      consumer.subscriptions.confirmSubscription(subscription.identifier);
    }
  });

  onBeforeUnmount(() => {
    const index = consumer.subscriptions.subscriptions.indexOf(subscription);
    consumer.subscriptions.subscriptions.splice(index, 1);
  });

  return subscription;
}
